// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["wwwroot_js_shared_BaseAddressViewModel_js"], function() { return __webpack_require__("./wwwroot/js/areas/account/login-register/LoginRegisterViewModel.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
